<template>
  <div
    id="dashboard-filter-container"
    class="d-flex align-items-center justify-content-between"
  >
    <div class="d-flex align-items-center" style="margin-top: 10px">
      <div  class="mb-2 date-filter-container">
        <date-range-picker
          ref="issuedate_datepicker"
          :startDate="issueStartDate"
          :endDate="issueEndDate"
          type="issue"
          header="Issue Date"
          @date-select="issueDateUpdateCallback"
        ></date-range-picker>
      </div>
      <div  class="mb-2 date-filter-container">
        <date-range-picker
          ref="duedate_datepicker"
          :startDate="startDate"
          :endDate="endDate"
          type="due"
          header="Due Date"
          @date-select="dueDateUpdateCallback"
        ></date-range-picker>
      </div>
      <div class="d-flex align-items-center" v-click-outside="closeMenu">
        <div style="position: relative" v-if="show_invoices_filter">
          <span class="header-label">Type</span>
          <div class="filter-label" @click="openMenu(1)">
            <span>
              {{ filter1.displayTitle }}
            </span>
            <img
              src="/images/up_arrow.png"
              alt="up_arrow"
              :style="`transform: rotate(${
                open_menu_index === 1 ? '0' : '180'
              }deg); height: 12px; width: 12px;`"
            />
          </div>
          <common-menu
            custom_style="left:8px;top:25px;"
            :open_menu="open_menu_index === 1"
            :menu_items="filter1List.map((item) => item.displayTitle)"
            :selected_item="filter1.displayTitle"
            @select_item="(item) => changeFilter(item, 'filter1', 'filter1List')"
          />
        </div>
        <div style="position: relative"   >
          <span class="header-label">Status</span>
          <div class="filter-label" @click="openMenu(2)">
            <span>
              {{ filter2.displayTitle }}
            </span>
            <img
              src="/images/up_arrow.png"
              alt="up_arrow"
              :style="`transform: rotate(${
                open_menu_index === 2 ? '0' : '180'
              }deg); height: 12px; width: 12px;`"
            />
          </div>
          <common-menu
            custom_style="left:8px;top:25px;"
            :open_menu="open_menu_index === 2"
            :menu_items="filter2List.map((item) => item.displayTitle)"
            :selected_item="filter2.displayTitle"
            @select_item="(item) => changeFilter(item, 'filter2', 'filter2List')"
          />
        </div>
        <div style="position: relative"   >
          <span class="header-label">Currency</span>
          <div class="filter-label" @click="openMenu(3)">
            <span>
              {{ filter3.displayTitle }}
            </span>
            <img
              src="/images/up_arrow.png"
              alt="up_arrow"
              :style="`transform: rotate(${
                open_menu_index === 3 ? '0' : '180'
              }deg); height: 12px; width: 12px;`"
            />
          </div>
          <common-menu
            custom_style="left:8px;top:25px;"
            :open_menu="open_menu_index === 3"
            :menu_items="filter3List.map((item) => item.displayTitle)"
            :selected_item="filter3.displayTitle"
            @select_item="(item) => changeFilter(item, 'filter3', 'filter3List')"
          />
        </div>
        <base-button
          class="clear-filters"
          stylevariant="hardlink"
          @click="resetFilter"
        >clear all
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "./DateRangePicker.vue";
import BaseButton from "@/components/UI/BaseButton.vue";
import CommonMenu from "@/components/common/menu.vue";

import {
  CURRENCIES_FILTER,
  ALL_INVOICES,
  RECEIVABLES,
  PAYABLES,
  INVOICE_STATES,
  QUERY_PARAMETERS,
} from "@/constants";
import { INVOICE_LOAD_QUERY_PARAMETERS } from "@/store/queryparams/page_load_query_params";
import {
  UPDATE_ALL_INVOICES,
  UPDATE_PAYABLES,
  UPDATE_RECEIVABLES,
} from "@/store/invoice";
import { QUERY_PARAMETERS_ACTIONS } from "@/store/queryparams";


export const invoiceTypeOptions = [
  {
    displayTitle: "All",
    state: ALL_INVOICES,
    updateCall: UPDATE_ALL_INVOICES,
  },
  {
    displayTitle: "Payables",
    state: ALL_INVOICES,
    updateCall: UPDATE_ALL_INVOICES,
  },
  {
    displayTitle: "Receivables",
    state: ALL_INVOICES,
    updateCall: UPDATE_ALL_INVOICES,
  },
];

export const invoiceStatusOptions = [
  {
  displayTitle:"All",
  value: null,
  },
  {
    displayTitle: "Paid",
    value: INVOICE_STATES.PAID,
  },
  {
    displayTitle: "Due",
    value: INVOICE_STATES.DUE,
  },
  {
    displayTitle: "Draft",
    value: INVOICE_STATES.DRAFT,
  },
  {
    displayTitle: "Overdue",
    value: INVOICE_STATES.OVERDUE,
  },
  {
    displayTitle: "Settled",
    value: INVOICE_STATES.SETTLED,
  },
  {
    displayTitle: "Rejected",
    value: INVOICE_STATES.REJECTED,
  },
  {
    displayTitle: "Voided",
    value: INVOICE_STATES.VOIDED,
  },
];

export default {
  components: { DateRangePicker, CommonMenu, BaseButton },
  name: "dashboard-filter",
  props: [
    "selected_tab",
    "show_invoices_filter",
    "issueDateUpdateCallback",
    "dueDateUpdateCallback",
    "showBatchPay"
  ],
  data() {
    return {
      filter1: invoiceTypeOptions[0],
      filter1List: invoiceTypeOptions,
      filter2: 
        (this.$route.query[QUERY_PARAMETERS.STATUS] &&
        invoiceStatusOptions.find((item) => {
        return item.value === this.$route.query[QUERY_PARAMETERS.STATUS];
        })) || invoiceStatusOptions[0],
      filter2List: invoiceStatusOptions,
      filter3: 
        (this.$route.query[QUERY_PARAMETERS.CURRENCY] &&
        CURRENCIES_FILTER.find((item) => {
          return item.value === this.$route.query[QUERY_PARAMETERS.CURRENCY];
        })) || CURRENCIES_FILTER[0],
      filter3List: CURRENCIES_FILTER,
      open_menu_index: null,
      startDate: INVOICE_LOAD_QUERY_PARAMETERS[QUERY_PARAMETERS.START_TIME],
      endDate: INVOICE_LOAD_QUERY_PARAMETERS[QUERY_PARAMETERS.END_TIME],
      issueStartDate: INVOICE_LOAD_QUERY_PARAMETERS[QUERY_PARAMETERS.ISSUE_START_TIME],
      issueEndDate: INVOICE_LOAD_QUERY_PARAMETERS[QUERY_PARAMETERS.ISSUE_END_TIME],
    };
  },
  methods: {
    openMenu(index) {
      if (this.open_menu_index === index) this.open_menu_index = null;
      else this.open_menu_index = index;
    },
    closeMenu(){
      this.open_menu_index = null;
    },
    changeFilter(displayTitle, field, fieldList) {
      const filter_index_object = this[fieldList].find(
        (filterOption) => filterOption.displayTitle === displayTitle
      );
      this[field] = filter_index_object;
      this.open_menu_index = null;
      this.$emit(`${field}-change`, filter_index_object);
    },
    resetFilter() {
      this.$emit('reset');
      this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS_WITH_FIRST_PAGE, {pageLoadVarsConstant: INVOICE_LOAD_QUERY_PARAMETERS, currentPageQueries: this.$route.query});
      this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.REMOVE_PARAMS_FROM_URL, this.$route.path);
      this.filter1 = invoiceTypeOptions[0];
      this.filter2 = invoiceStatusOptions[0];
      this.filter3 = CURRENCIES_FILTER[0];
      this.$refs['issuedate_datepicker'].resetDate(
        INVOICE_LOAD_QUERY_PARAMETERS[QUERY_PARAMETERS.START_TIME],
        INVOICE_LOAD_QUERY_PARAMETERS[QUERY_PARAMETERS.END_TIME],
      );
      this.$refs['duedate_datepicker'].resetDate(
        INVOICE_LOAD_QUERY_PARAMETERS[QUERY_PARAMETERS.START_TIME],
        INVOICE_LOAD_QUERY_PARAMETERS[QUERY_PARAMETERS.END_TIME],
      );
    },
    selectTab(index) {
      this.$parent.selectTab(index);
    },
    recallDateSelect(dateParameter) {
      this.$emit('date-select', dateParameter);
    },
    batchPay() {
      this.$emit("batchPay");
    },
    payAllInvoices() {
      this.$emit("payAllInvoices");
    }
  },
};
</script>

<style scoped lang="scss">
@import './filter.scss';
</style>
